import React from "react";
import { Formik } from "formik";
import Edit from "../../../assets/images/editinput.svg"

export default function RiskCreate(props) {

  return (
    <div>
      <div className="row text-right pt-3">
        <div className="col-md-12">
          <span className='appkiticon icon-arrow-left-outline pointer back-fill' onClick={props.handleBack1}></span>
        </div>

      </div>
      <Formik
      >
        {(props) => {
          return (
            <div className="">
              <form >
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Third Party Name
                    </label>
                      <input
                        className="cv-input-field"
                        type="text"
                        name="thirdPartyName"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Information Classification</label>
                      <input
                        className="cv-input-field"
                        type="text"
                        name="Infoclassification"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">Service Name</label>
                      <input
                        className="cv-input-field"
                        type="text"
                        name="Servicename"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Over View of the Risk
                      </label>
                      <input
                        className="cv-input-field"
                        type="text"
                        name="riskOverView"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Brief Description of
                      </label>
                      <input
                        className="cv-input-field"
                        type="text"
                        name="BriefDescription"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>

                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Issues
                      </label>
                      <input
                        className="cv-input-field"
                        type="text"
                        name="Contract"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Business Owner
                    </label>
                      <input
                        className="cv-input-field"
                        type="text"
                        name="BusinessOwner"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Date Logged
                    </label>
                      <input
                        className="cv-input-field"
                        type="date"
                        name="DateLogged"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Duration
                    </label>
                      <input
                        className="cv-input-field"
                        type="text"
                        name="duration"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Date Issued
                    </label>
                      <input
                        className="cv-input-field"
                        type="date"
                        name="DateIssued"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Expiry Date
                    </label>
                      <input
                        className="cv-input-field"
                        type="date"
                        name="expirydate"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Issues
                    </label>
                      <input
                        className="cv-input-field"
                        type="text"
                        name="Riskrating"
                      />
                    </div>
                  </div>
                </div>
                <div className="options-container">
                  <button
                    type="submit"
                    className="save-button m-l-2"
                  >Create
                </button>
                  <button
                    type="submit"
                    className="save-button m-l-2"
                  >Save
                </button>
                  <button className="cancel-button m-l-2" type="reset">Cancel</button>

                </div>
              </form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
}
